module.exports = __webpack_public_path__ + "static/media/user.dd404aea.svg";